import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import ModalForm from "../../../components/Modal/ModalForm";
import RequisitoTable from "./RequisitoTable";

import { addRequisito, consultaRequisitos, editRequisito } from "../../../funciones/AdmisionFunction";

let boton = 0;
let idRequisito = "";

class AdmisionMem extends Component {
    state = {
        openW: false,
        button: {
            icon: "fa fa-save",
            text: "Guardar"
        },
        buttonEdit: {
            icon: "fa fa-edit",
            text: "Actualizar"
        },
        texto: "",
        requisitos: [],
        preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando lista de requisitos</React.Fragment>,
        md1: 9,
        md2: 3
    }

    constructor (props) {
        super (props)

        consultaRequisitos ((resp)=> {
            if (resp.length === 0) {
                this.setState({ preloader: "No existen requisitos registrados" })
            }else{
                this.setState({ requisitos: resp })
            }
        })
    }

    cerrarModal = () => {
        this.setState ({
            openW: false,
        })
    }

    cambiaValor = (prop) => (e) => {
        this.setState({[prop]: e.target.value})
    }

    guardar = () => {

        this.setState({
            button: {
                icon: "fa fa-spinner fa-spin",
                text: "Espera"
            }
        }, () => {
            if (this.state.texto === "") {
                this.setState({
                    button: {
                        icon: "fa fa-save",
                        text: "Guardar"
                    }
                }, () => {
                    toast.error("El campo Requisito es obligatorio",{autoClose: 4000});
                })
            }else{
                addRequisito (this.state.texto, () => {
                    this.setState({
                        button: {
                            icon: "fa fa-save",
                            text: "Guardar"
                        },
                        texto: ""
                    }, () => {
                        toast.info("Se ha añadido correctamente el requisito",{autoClose: 4000});
                        consultaRequisitos ((resp)=> {
                            if (resp.length === 0) {
                                this.setState({ preloader: "No existen requisitos registrados" })
                            }else{
                                this.setState({ requisitos: resp })
                            }
                        })
                    })
                })
            }
        })
    }

    editar = () => {
        this.setState({
            buttonEdit: {
                icon: "fa fa-spinner fa-spin",
                text: "Espera"
            }
        }, () => {
            if (this.state.texto === "") {
                this.setState({
                    buttonEdit: {
                        icon: "fa fa-edit",
                        text: "Actualizar"
                    }
                }, () => {
                    toast.error("El campo Requisito es obligatorio",{autoClose: 4000});
                })
            }else{
                editRequisito (idRequisito, this.state.texto, () => {
                    this.setState({
                        buttonEdit: {
                            icon: "fa fa-edit",
                            text: "Actualizar"
                        },
                        texto: ""
                    }, () => {
                        boton = 0;
                        idRequisito = "";
                        toast.info("Se ha actualizado correctamente el requisito",{autoClose: 4000});
                        consultaRequisitos ((resp)=> {
                            if (resp.length === 0) {
                                this.setState({
                                    preloader: "No existen requisitos registrados",
                                    texto: "",
                                    md1: 9,
                                    md2: 3
                                })
                            }else{
                                this.setState({
                                    requisitos: resp,
                                    texto: "",
                                    md1: 9,
                                    md2: 3
                                })
                            }
                        })
                    })
                })
            }
        })
    }

    cancelar = () => {
        boton = 0;
        idRequisito = "";
        this.setState({
            texto: "",
            md1: 9,
            md2: 3
        })
    }

    listrequisitos = () => {
        let { requisitos, preloader } = this.state;

        if (requisitos.length === 0) return (
            <tr>
                <td align="center" width="100%" colSpan={2}>{preloader}</td>
            </tr>
        )

        let editRequisito = (id, text) => {
            boton = 1;
            idRequisito = id;

            this.setState({
                texto: text,
                md1: 8,
                md2: 4
            })
        }

        return (
            requisitos.map(option => (
                <RequisitoTable key={option.id} datos={option}
                    funcionEdit = {(id, text) => {editRequisito(id, text)}}
                    updListado = { () => {
                        consultaRequisitos ((resp)=> {
                            if (resp.length === 0) {
                                this.setState({
                                    requisitos: resp,
                                    preloader: "No existen requisitos registrados"
                                })
                            }else{
                                this.setState({ requisitos: resp })
                            }
                        })
                    }}
                />
            ))
        )
    }

    botones = () => {
        let { button, buttonEdit } = this.state;

        switch (boton) {
            case 0:
                return (
                    <button className="btn btn-primary" style={{borderWidth: 1}} onClick={this.guardar} title="Agregar el nuevo requisito"><i className={button.icon}></i> {button.text}</button>
                )
            case 1:
                return (
                    <div className="btn-group">
                        <button className="btn btn-primary" style={{borderWidth: 1}} onClick={this.cancelar}><i className="fa fa-times"></i> Cancelar</button>
                        <button className="btn btn-warning" style={{borderWidth: 1}} onClick={this.editar} title="Editar este requisito"><i className={buttonEdit.icon}></i> {buttonEdit.text}</button>
                    </div>
                )
            default:
                return null
        } 


    }

    modal = () => {
        let { openW, texto, md1, md2 } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let contenidoModal = () => (
            <React.Fragment>
                <div className="custom-alert-success" style={{padding: 5}}><i className="fa fa-plus-square"></i>Agrega un Nuevo Requisito</div>
                <Row className="custom-mt-10">
                    <Col md={md1}>
                        <textarea className="form-control" value={texto} onChange={this.cambiaValor("texto")}></textarea>
                    </Col>
                    <Col md={md2} align = "right">
                        {this.botones()}
                    </Col>
                </Row>
                <div className="custom-alert-info custom-mt-10" style={{padding: 5}}><i className="fa fa-file"></i>Requisitos agregados</div>

                <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "52vh", overflowX:"hidden"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td align="center" width="85%" style={styles}><strong>Requisitos</strong></td>
                                <td align="center" width="15%" style={styles}><strong>Acciones</strong></td>
                            </tr>
                            {this.listrequisitos()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )

        return (
            <ModalForm
                isopen =  {openW}
                titulo = {<div>Agregar o Editar Requisitos para la Admisión</div>}
                contenido = {contenidoModal()}
                cerrar = {this.cerrarModal}
            />
        );
    }

    render() { 
        return (
            <React.Fragment>
                <Row>
                    <Col md={7}>
                        <div style={{marginTop: 10}}><i className="fa fa-address-book"></i> Admisión</div>
                    </Col>
                    <Col md={5}align="right">
                        <button className="btn btn-relleno-primary" onClick ={() => { this.setState({openW: true}) }} title="Agregar/Editar los requisitos para la admisión" style={{borderWidth: 1}}><i className="fa fa-edit"></i>Requisitos</button>
                    </Col>
                </Row>
                {this.modal()}
            </React.Fragment>
        );
    }
}
 
export default AdmisionMem;


// WEBPACK FOOTER //
// ./src/views/Registros/PreferenciasContent/AdmisionMem.jsx